module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAG1JREFUOE/N0tEJwCAMBNDcZl2inafztEt0sysNRZREieRH/4S7BzFCkgfJviwEkDxnxgGg+TICSU4C2q2BXUSuIHIAuBvgu5CMIKVsgADSlF1ggJhyF3AQtzwEfmTTEPD0Hnehnxjcv4mlR3gB9oUlERoZPi8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottomSJ.png
// module id = XHb6
// module chunks = 1